// @ts-check
/** @typedef {import('../types/api').AdminUser} AdminUser */
/** @typedef {import('../types/api').PaginatedAdminUsers} PaginatedAdminUsers */
/** @typedef {import('../types/api').AdminUserRole} AdminUserRole */
/** @typedef {import('../types/api').AdminUserPermissions} AdminUserPermissions */

import api from '../utils/apiClient';
import { assertArray, assertShape } from '../utils/apiGuards';

const adminUserService = {
  /**
   * @param {Object} [params]
   * @returns {Promise<PaginatedAdminUsers>}
   */
  getAllUsers: async ({ page, limit } = {}) => {
    const params = new URLSearchParams();
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    const query = params.toString();
    const data = await api.get(`/api/admin/users/${query ? `?${query}` : ''}`);
    assertShape(data, ['items', 'total'], 'adminUserService.getAllUsers');
    return data;
  },

  /**
   * @param {string} userId
   * @param {string} role
   * @returns {Promise<AdminUser>}
   */
  updateUserRole: async (userId, role) => {
    return api.put(`/api/admin/users/${userId}/role`, { role });
  },

  /**
   * @returns {Promise<AdminUserRole[]>}
   */
  getAvailableRoles: async () => {
    const data = await api.get('/api/admin/users/roles');
    assertArray(data, 'adminUserService.getAvailableRoles');
    return data;
  },

  /**
   * @returns {Promise<AdminUserPermissions>}
   */
  getCurrentUserPermissions: async () => {
    const data = await api.get('/api/admin/users/permissions');
    assertShape(data, ['permissions', 'role'], 'adminUserService.getCurrentUserPermissions');
    return data;
  },
};

export default adminUserService;
